import { deltaTone, formatDeltaPct } from "@/analytics/core/format-delta";
import { cn } from "@/lib/cn";
import { TrendingDown, TrendingUp } from "lucide-react";

interface ComparisonDeltaProps {
  deltaPct: number | null;
  compareLabel?: string;
  className?: string;
}

export function ComparisonDelta({ deltaPct, compareLabel, className }: ComparisonDeltaProps) {
  const tone = deltaTone(deltaPct);

  return (
    <div className={cn("flex items-center gap-2 text-sm", className)}>
      <span
        className={cn(
          "inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium",
          tone === "positive" && "bg-[#EAF6F2] text-[#4F8A7A]",
          tone === "negative" && "bg-[#FAF0ED] text-[#B07A6C]",
          tone === "neutral" && "bg-[#F1F5F9] text-[#94A3B8]",
        )}
      >
        {tone === "positive" ? (
          <TrendingUp className="h-3.5 w-3.5" />
        ) : tone === "negative" ? (
          <TrendingDown className="h-3.5 w-3.5" />
        ) : null}
        {formatDeltaPct(deltaPct)}
      </span>
      {compareLabel ? (
        <span className="text-right text-[#94A3B8] leading-snug">vs {compareLabel}</span>
      ) : null}
    </div>
  );
}
